var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackToTop = function SvgBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#back-to-top_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 15,
    y: 8,
    fill: "#fff",
    rx: 30
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005098",
    fillRule: "evenodd",
    d: "M39.365 42.723a1.613 1.613 0 0 1-2.222 0c-.635-.591-.635-1.478 0-2.07l6.825-6.21a1.614 1.614 0 0 1 2.222 0l6.667 6.21c.635.592.635 1.479 0 2.07a1.613 1.613 0 0 1-2.222 0l-3.968-3.696v8.306a1.667 1.667 0 1 1-3.334 0V39.13zM36.667 30.667c0-.92.746-1.667 1.666-1.667h13.334a1.667 1.667 0 1 1 0 3.333H38.332c-.92 0-1.666-.746-1.666-1.666",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "back-to-top_svg__a",
    width: 90,
    height: 90,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.165799 0 0 0 0 0.19289 0 0 0 0 0.795833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgBackToTop;